export enum LOADER_CONST {
  BASE_TEST_ID = 'loader',
  FULLSCREEN_TEST_ID = 'loader-fullscreen',
}

export type LoaderFullScreenProps = {
  message: string;
};
